import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Fontes Patrium — self-hosted (mantém a CSP `font-src 'self'`, sem CDN externo).
// Space Grotesk (wordmark/títulos/display) + Inter (corpo/tabelas/interface).
import '@fontsource/space-grotesk/400.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@/styles/globals.css'
import { App } from './App'
import { enableMockBff, setupTrustedTypes } from '@/lib/boot'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error(
    '[PPM.PAGO] Elemento #root não encontrado no DOM. Verifique o index.html.',
  )
}

setupTrustedTypes()

void enableMockBff().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
